import { useCallback, useEffect, useState } from "react";
import Search from "../../../CommonComponents/Search";
import IconButton from "../../../CommonComponents/IconButton";
import Tooltip from "../../../CommonComponents/Tooltip";
import PaginationComponent from "../../../CommonComponents/PaginationComponent";
import Table from "../../../CommonComponents/Table";
import { useContext } from "react";
import AlertContext from "../../../../context/AlertContext";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import { useNavigate, useParams } from "react-router-dom";
import ReportTypesCard from "./ReportTypesCard";
import constants from "../../../../constants";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import Loading from "../../../Notification-Loading/Loading/Loading";
import { useRef } from "react";
import ExportPdf from "../../Dashboard/ExportPdf";
import ExportToCsv from "../../Dashboard/ExportToCsv";
import MockTestLibraryHooks from "../../../../Hooks/Mock/Student/MockTestLibraryHooks";
import MockTestResultsHooks from "../../../../Hooks/Mock/Student/MockTestResultsHooks";
import Drawer from "../../../CommonComponents/Drawer";
import AttemptCard from "../../../Student/MockTestPage/AttemptScoreCard";
import { getDataFromStorage } from "../../../../util";
import GraphForAttempts from "../../../Student/MockTestPage/GraphForAttempts";

import NameCell from "../../../CommonComponents/NameCell";
import { UserReportProvider } from "../../../../context/UserReportContext";

const MockTestReport = ({ learnerId, fromPage = "activitpage" }) => {
  const Alert = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const MockTestLibraryHks = MockTestLibraryHooks();
  const MockTestResultsHks = MockTestResultsHooks();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();
  const [testData, setTestData] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();
  const downloadIconRef = useRef(null);
  const { renderDataToPDF } = ExportPdf();
  const { downloadIndividualExcel } = ExportToCsv();
  //helper related
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebouncedValue(searchValue, 2000);
  const containerRef = useRef(null);
  const scrollDir = useRef("right");
  const [isHovered, setIsHovered] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [attemptedData, setAttemptedData] = useState([]);
  const [clickedRow, setClickedRow] = useState([]);
  const [clickedColumn, setClickedColumn] = useState([]);
  const [clickedRowLearnerId, setClickedRowLearnerId] = useState(null);
  const [clickedLearnerName, setClickedLearnerName] = useState(null);
  const DownloadIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 12.5V15.8333C17 16.2754 16.8244 16.6993 16.5118 17.0118C16.1993 17.3244 15.7754 17.5 15.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M6.33333 8.33333L10.5 12.5M10.5 12.5L14.6667 8.33333M10.5 12.5V2.5"
        stroke="#667085"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  //table data related
  const [isDataLoading, setIsDataLoading] = useState(false);
  const activityColumn = [
    {
      key: "Topic",
      title: "Topic",
      className: "Topic",
    },
    {
      key: "Score",
      title: "Score",
      className: "Score",
    },
  ];
  const [data, setData] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);
  const [totalPagesForPagination, setTotalPagesForPagination] = useState(1);
  const pageSize = 10;
  const [arr, setArr] = useState([]);
  const stored = localStorage.getItem("account_response");
  const [enabledFeatures, setEnableFeatures] = useState([]);

  useEffect(() => {
    if (stored) {
      try {
        const decoded = JSON.parse(atob(stored));

        // axios response structure
        const companies = decoded || {};

        const companyId = parseInt(getDataFromStorage("companyId"), 10);
        console.log("comapnyID : ", companyId);
        // console.log("comapnies : ",companies);
        // const selectedCompany = companies.find(c => c.id === companyId);

        if (companies.premium_features) {
          const features = JSON.parse(companies.premium_features);

          setEnableFeatures(
            features.map(
              (feature) =>
                feature.premium_feature_name ??
                feature.premium_features ??
                feature.name,
            ),
          );
          localStorage.setItem(
            "enabled_features",
            btoa(JSON.stringify(features)),
          );
        }
      } catch (error) {
        console.error("Error decoding accounts_response:", error);
      }
    }
  }, [stored]);

  useEffect(() => {
    let temp = [];
    if (enabledFeatures.includes("mcq")) {
      temp.push(2);
      console.log("condition 1 HIT");
    }
    if (enabledFeatures.includes("coding_challenge_test")) {
      temp.push(5);
      console.log("condition 2 HIT");
    }
    if (enabledFeatures.includes("descriptive")) {
      temp.push(3);
      console.log("condition 3 HIT");
    }
    if (enabledFeatures.includes("coding_snippet")) {
      temp.push(12);
      console.log("condition 4 HIT");
    }
    setArr(temp);
  }, [enabledFeatures]);

  const handleResponse = useCallback(
    (title, msg) => {
      Alert.setShowNotify({
        show: true,
        title: title,
        msg: msg,
      });
    },
    [Alert],
  );

  const [headerData, setHeaderData] = useState([
    {
      svg: (
        <svg
          width="19"
          height="16"
          viewBox="0 0 19 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8323 7.50827L6.56979 7.50827M17.8323 1.87702L6.56979 1.87702M17.8323 13.1395L6.56979 13.1395M2.81562 7.50827C2.81562 8.02661 2.39543 8.44681 1.87708 8.44681C1.35874 8.44681 0.938541 8.02661 0.938541 7.50827C0.938541 6.98993 1.35874 6.56973 1.87708 6.56973C2.39543 6.56973 2.81562 6.98993 2.81562 7.50827ZM2.81562 1.87702C2.81562 2.39536 2.39543 2.81556 1.87708 2.81556C1.35874 2.81556 0.938541 2.39536 0.938541 1.87702C0.938541 1.35868 1.35874 0.938477 1.87708 0.938477C2.39543 0.938477 2.81562 1.35868 2.81562 1.87702ZM2.81562 13.1395C2.81562 13.6579 2.39543 14.0781 1.87708 14.0781C1.35874 14.0781 0.938541 13.6579 0.938541 13.1395C0.938541 12.6212 1.35874 12.201 1.87708 12.201C2.39543 12.201 2.81562 12.6212 2.81562 13.1395Z"
            stroke="#12B76A"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "MCQ'S",
      count: 0,
      style: { backgroundColor: "#FFEFE3" },
    },
    {
      svg: (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0167 14.0783L19.7094 9.3856L15.0167 4.69289M5.63125 4.69289L0.938538 9.3856L5.63125 14.0783M12.201 0.938721L8.44687 17.8325"
            stroke="#F79009"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Coding Challenges",
      count: 0,
      style: { backgroundColor: "#FAEBD7" },
    },
    {
      svg: (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.324 19.7093C15.5074 19.7093 19.7094 15.5073 19.7094 10.3239C19.7094 5.14047 15.5074 0.938477 10.324 0.938477C5.14053 0.938477 0.938538 5.14047 0.938538 10.3239C0.938538 15.5073 5.14053 19.7093 10.324 19.7093Z"
            stroke="#F04438"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.9776 7.47573C7.9776 7.02778 7.9776 6.8038 8.07121 6.67876C8.15279 6.5698 8.27766 6.50162 8.41344 6.49192C8.56924 6.4808 8.75764 6.60191 9.13445 6.84415L13.5649 9.69231C13.8919 9.90251 14.0554 10.0076 14.1119 10.1412C14.1612 10.258 14.1612 10.3898 14.1119 10.5065C14.0554 10.6402 13.8919 10.7453 13.5649 10.9555L9.13445 13.8036C8.75764 14.0459 8.56924 14.167 8.41344 14.1559C8.27766 14.1462 8.15279 14.078 8.07121 13.969C7.9776 13.844 7.9776 13.62 7.9776 13.1721V7.47573Z"
            stroke="#F04438"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Video Assessments",
      count: 0,
      style: { backgroundColor: "#FFF4E6" },
    },
    {
      svg: (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3016 18.6097H10.7933M0.938599 19.079L6.14682 17.0759C6.47995 16.9477 6.64651 16.8837 6.80234 16.8C6.94076 16.7257 7.07272 16.64 7.19683 16.5436C7.33656 16.4352 7.46275 16.309 7.71513 16.0566L18.3016 5.47016C19.3383 4.43347 19.3383 2.75268 18.3016 1.71599C17.265 0.679306 15.5842 0.679305 14.5475 1.71599L3.96097 12.3025C3.70859 12.5549 3.5824 12.681 3.47397 12.8208C3.37766 12.9449 3.2919 13.0769 3.2176 13.2153C3.13395 13.3711 3.06988 13.5377 2.94176 13.8708L0.938599 19.079ZM0.938599 19.079L2.87023 14.0568C3.00846 13.6975 3.07757 13.5178 3.19611 13.4355C3.29971 13.3635 3.4279 13.3363 3.55178 13.36C3.69353 13.387 3.82967 13.5232 4.10194 13.7955L6.22219 15.9157C6.49446 16.188 6.63059 16.3241 6.65766 16.4659C6.68132 16.5897 6.65412 16.7179 6.58219 16.8215C6.49988 16.9401 6.32019 17.0092 5.9608 17.1474L0.938599 19.079Z"
            stroke="#F79009"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Descriptive",
      count: 0,
      style: { backgroundColor: "#E6FFE6" },
    },
    {
      svg: (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7094 6.56973H0.938538M12.201 14.5473L14.5474 12.201L12.201 9.85462M8.44687 9.85462L6.10052 12.201L8.44687 14.5473M0.938538 5.44348L0.938538 13.3272C0.938538 14.9041 0.938538 15.6926 1.24542 16.2949C1.51537 16.8247 1.9461 17.2554 2.4759 17.5253C3.07819 17.8322 3.86664 17.8322 5.44354 17.8322H15.2044C16.7813 17.8322 17.5697 17.8322 18.172 17.5253C18.7018 17.2554 19.1325 16.8247 19.4025 16.2949C19.7094 15.6926 19.7094 14.9041 19.7094 13.3272V5.44348C19.7094 3.86658 19.7094 3.07813 19.4025 2.47584C19.1325 1.94604 18.7018 1.51531 18.172 1.24536C17.5697 0.938478 16.7813 0.938478 15.2044 0.938478L5.44354 0.938477C3.86664 0.938476 3.07819 0.938476 2.4759 1.24536C1.9461 1.5153 1.51537 1.94604 1.24542 2.47583C0.938538 3.07813 0.938538 3.86658 0.938538 5.44348Z"
            stroke="#2E90FA"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Coding Snippet",
      count: 0,
      style: { backgroundColor: "#E6EFFF" },
    },
  ]);
  //pagination
  const [paginationPageNo, setPaginatinoPageNo] = useState(1);
  const [showDownloadOptionsDropDown, setShowDownloadOptionsDropDown] =
    useState(false);

  useEffect(() => {
    setPaginatinoPageNo(1);
  }, [debouncedSearchValue]);
  useEffect(() => {
    const clickOutSide = (e) => {
      if (
        downloadIconRef.current &&
        !downloadIconRef.current.contains(e.target)
      ) {
        setShowDownloadOptionsDropDown(false);
      }
    };
    if (showDownloadOptionsDropDown) {
      document.addEventListener("mousedown", clickOutSide);
    }
    return () => {
      document.removeEventListener("mousedown", clickOutSide);
    };
  }, [showDownloadOptionsDropDown]);
  const handlePageChange = (newPage) => {
    setPaginatinoPageNo(newPage);
  };
  // const getTestColumnKey = (test, index) => {
  //   if (test?.tid) return `${test.tname}_${test.tid}`;
  //   return `${test.tname}${index}`;
  // };
  //api call
  useEffect(() => {
    const fetchTableData = async () => {
      console.log("HIT Step 1");
      try {
        setIsDataLoading(true);
        console.log("HIT Step 2");
        const response = await axios.get(
          `/node/admin/mock-test/report${
            fromPage === "reportpage"
              ? `?bid=${id}&name=${searchValue}&page=${paginationPageNo}&limit=${pageSize}`
              : `?learnerId=${learnerId}`
          }`,
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );
        console.log("HIT Step 3");
        // if (response.data.resultCode !== 1000) {
        //   Alert.setShowNotify({
        //     show: true,
        //     title: "Info",
        //     msg: response.data.msg,
        //   });
        //   throw new Error(
        //     "Something went wrong while fetching report of the student"
        //   );
        // }

        if (response?.data?.resultCode === constants.RESULT_STATUS.NO_DATA) {
          setData([]);
          setHeaderData((prev) =>
            prev.map((p) => {
              switch (p.name) {
                case "MCQ'S":
                  return {
                    ...p,
                    count: 0,
                  };
                case "Coding Challenges":
                  return {
                    ...p,
                    count: 0,
                  };
                case "Video Assessments":
                  return {
                    ...p,
                    count: 0,
                  };
                case "Descriptive":
                  return {
                    ...p,
                    count: 0,
                  };
                case "Coding Snippet":
                  return {
                    ...p,
                    count: 0,
                  };
                default:
                  return p;
              }
            }),
          );
        }
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          if (fromPage === "reportpage") {
            console.log("Report side Response data : ", response.data.data);
            const uniqueKeys = new Set();
            const baseColumns = [
              { key: "Name", title: "Name", className: "Name" },
            ];
            // console.log("array : ", arr);
            const totalPages = Math.ceil(response?.data?.total / 10);
            setTotalPagesForPagination(totalPages);
            console.log("Total learners:", response.data.data.length);
            response.data.data.forEach((res) => {
              res?.tests?.forEach((test) => {
                const columnKey = `test_${test.tid}`;
                if (uniqueKeys.has(columnKey)) return;
                if (test.aiMode) return;
                if (!arr.includes(test.libtype)) return;
                uniqueKeys.add(columnKey);
                baseColumns.push({
                  title: test.tname,
                  key: columnKey,
                  className: columnKey,
                });
              });
            });
            let rowData = [];
            response.data.data.forEach((res) => {
              let infoData = {};
              infoData["Name"] = normalizeLetters(res.lname);
              infoData["learnerid"] = res.lid;
              res?.tests?.forEach((test) => {
                let attemptedLength = test.attempteddata.length;
                const parseDate = (dateStr) =>
                  new Date(dateStr.replace(" ", "T").split(".")[0]);
                let lastMockTestDetails = test.attempteddata.reduce(
                  (latest, item) => {
                    if (!item.submitteddate) return latest;
                    if (
                      !latest ||
                      parseDate(item.submitteddate) >
                        parseDate(latest.submitteddate)
                    ) {
                      return item;
                    }
                    return latest;
                  },
                  null,
                );
                // console.log("lastMockTestDetails:",lastMockTestDetails,test.tid);

                if (attemptedLength >= 2) {
                  infoData[`test_${test.tid}_hower`] = true;
                }
                if (
                  lastMockTestDetails?.lmpid === null ||
                  lastMockTestDetails?.lmpid === undefined
                ) {
                  infoData[`test_${test.tid}`] = `-`;
                } else {
                  infoData[`test_${test.tid}`] = `${
                    lastMockTestDetails?.actualscore ?? 0
                  }/${lastMockTestDetails?.targetscore}`;
                  infoData[`test_${test.tid}_lmpid`] =
                    lastMockTestDetails.lmpid;
                  infoData[`test_${test.tid}_lmtid`] =
                    lastMockTestDetails.lmtid;
                  infoData[`test_${test.tid}_libtype`] = test.libtype;
                  infoData[`test_${test.tid}_videoqn`] =
                    lastMockTestDetails.isVideoQn ?? 0;
                  infoData[
                    `test_${test.tid}_${
                      lastMockTestDetails.lmpid
                        ? lastMockTestDetails?.lmpid
                        : ""
                    }_status`
                  ] = lastMockTestDetails.status;
                }
              });
              rowData.push(infoData);
            });
            setData(rowData);
            Alert.setMockTestReportTopic(baseColumns);
            Alert.setMockTestReportTopic((prev) => prev.slice(1));
            setReportColumns(baseColumns);
          } else if (fromPage === "activitypage") {
            let curr = [];
            let mcqAttempted = 0;
            let ccAttempted = 0;
            let videoAttempted = 0;
            let descAttempted = 0;
            let codingSnippets = 0;
            let tests = response?.data?.data?.[0];
            tests?.tests?.forEach((test) => {
              let rowData = {};
              rowData["Topic"] = test?.tname;
              rowData["Libtype"] = test?.libtype;
              rowData["aiMode"] = test?.aiMode ?? 0;
              rowData["autoEval"] = test?.autoEval ?? 0;
              const parseDate = (dateStr) =>
                new Date(dateStr.replace(" ", "T").split(".")[0]);
              let lastTest = test.attempteddata.reduce((latest, item) => {
                if (!item.submitteddate) return latest;
                if (
                  !latest ||
                  parseDate(item.submitteddate) >
                    parseDate(latest.submitteddate)
                ) {
                  return item;
                }
                return latest;
              }, null);
              rowData["Score"] = `${lastTest?.actualscore ?? 0}/${
                lastTest?.targetscore ?? 0
              }`;
              rowData["isVideoQn"] = lastTest?.isVideoQn ?? 0;
              if (test?.libtype === constants.libTypeIds.MCQ) {
                mcqAttempted++;
              } else if (
                test?.libtype === constants.libTypeIds.CODING_CHALLENGE
              ) {
                ccAttempted++;
              } else if (
                test?.libtype === constants.libTypeIds.DESCRIPTIVE &&
                lastTest?.isVideoQn === 1
              ) {
                videoAttempted++;
              } else if (
                test?.libtype === constants.libTypeIds.CODING_SNIPPET
              ) {
                codingSnippets++;
              } else if (test?.libtype === constants.libTypeIds.DESCRIPTIVE) {
                descAttempted++;
              }
              curr.push(rowData);
            });
            setData(curr);
            setHeaderData((prev) =>
              prev.map((p) => {
                switch (p.name) {
                  case "MCQ'S":
                    return {
                      ...p,
                      count: `${mcqAttempted}`,
                    };
                  case "Coding Challenges":
                    return {
                      ...p,
                      count: `${ccAttempted}`,
                    };
                  case "Video Assessments":
                    return {
                      ...p,
                      count: `${videoAttempted}`,
                    };
                  case "Descriptive":
                    return {
                      ...p,
                      count: `${descAttempted}`,
                    };
                  case "Coding Snippet":
                    return {
                      ...p,
                      count: `${codingSnippets}`,
                    };
                  default:
                    return p;
                }
              }),
            );
          }
        }
      } catch (error) {
        console.error(error);
        handleResponse("Error", error.message);
      } finally {
        setIsDataLoading(false);
      }
    };
    if (arr.length === 0) return;
    fetchTableData();
  }, [arr, learnerId, paginationPageNo, debouncedSearchValue]);

  const normalizeLetters = (name) => {
    if (!name) return ""; // handle null/undefined/empty
    const trimmed = name.trim();
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };
  const fetchAllDataForDownload = async () => {
    try {
      setIsDataLoading(true);
      const response = await axios.get(
        `/node/admin/mock-test/report?allLearner=true&bid=${id}`,
        useCommonFunctionHks.getHeaderDetailsForAxios(),
      );
      return response?.data?.data ?? [];
    } catch (error) {
      console.error(error);
      handleResponse("Error", error.message);
    } finally {
      setIsDataLoading(false);
    }
  };

  const handlePdfDownload = async () => {
    const allData = await fetchAllDataForDownload();

    if (allData && allData.length > 0) {
      const downloadData = prepareDownloadData(allData);
      const orientation = "landscape";
      renderDataToPDF(downloadData, orientation, "a0", `Mocktest_Report`);
    }
    setShowDownloadOptionsDropDown(false);
  };

  // Handle CSV download
  const handleCsvDownload = async () => {
    const allData = await fetchAllDataForDownload();
    if (allData && allData.length > 0) {
      const downloadData = prepareDownloadData(allData);
      downloadIndividualExcel(downloadData, `MOcktest_Report`);
    }
    setShowDownloadOptionsDropDown(false);
  };

  const prepareDownloadData = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }
    const result = data.map((student) => {
      const row = {
        Name: student.lname,
      };

      student.tests.forEach((test) => {
        let attemptedLength = test.attempteddata.length - 1;
        let lastMockTestDetails = test.attempteddata[attemptedLength];
        row[test.tname.trim()] = `${lastMockTestDetails?.actualscore ?? "-"}/${
          lastMockTestDetails?.targetscore
        }`;
      });
      return row;
    });
    return result;
  };

  const handleCardClick = () => {
    const container = containerRef.current;
    if (!container) return;

    const scrollAmount = container.firstChild?.offsetWidth + 20; // card + gap

    if (scrollDir.current === "right") {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
      scrollDir.current = "left";
    } else {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      scrollDir.current = "right";
    }
  };

  const getIcon = (libtype, isVideoQn, autoEval, aiMode) => {
    if (libtype === constants.libTypeIds.MCQ) {
      return (
        <svg
          width="19"
          height="16"
          viewBox="0 0 19 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8323 7.50827L6.56979 7.50827M17.8323 1.87702L6.56979 1.87702M17.8323 13.1395L6.56979 13.1395M2.81562 7.50827C2.81562 8.02661 2.39543 8.44681 1.87708 8.44681C1.35874 8.44681 0.938541 8.02661 0.938541 7.50827C0.938541 6.98993 1.35874 6.56973 1.87708 6.56973C2.39543 6.56973 2.81562 6.98993 2.81562 7.50827ZM2.81562 1.87702C2.81562 2.39536 2.39543 2.81556 1.87708 2.81556C1.35874 2.81556 0.938541 2.39536 0.938541 1.87702C0.938541 1.35868 1.35874 0.938477 1.87708 0.938477C2.39543 0.938477 2.81562 1.35868 2.81562 1.87702ZM2.81562 13.1395C2.81562 13.6579 2.39543 14.0781 1.87708 14.0781C1.35874 14.0781 0.938541 13.6579 0.938541 13.1395C0.938541 12.6212 1.35874 12.201 1.87708 12.201C2.39543 12.201 2.81562 12.6212 2.81562 13.1395Z"
            stroke="#12B76A"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (libtype === constants.libTypeIds.CODING_CHALLENGE) {
      return (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0167 14.0783L19.7094 9.3856L15.0167 4.69289M5.63125 4.69289L0.938538 9.3856L5.63125 14.0783M12.201 0.938721L8.44687 17.8325"
            stroke="#F79009"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (
      libtype === constants.libTypeIds.DESCRIPTIVE &&
      isVideoQn === 1
    ) {
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.324 19.7093C15.5074 19.7093 19.7094 15.5073 19.7094 10.3239C19.7094 5.14047 15.5074 0.938477 10.324 0.938477C5.14053 0.938477 0.938538 5.14047 0.938538 10.3239C0.938538 15.5073 5.14053 19.7093 10.324 19.7093Z"
            stroke="#F04438"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.9776 7.47573C7.9776 7.02778 7.9776 6.8038 8.07121 6.67876C8.15279 6.5698 8.27766 6.50162 8.41344 6.49192C8.56924 6.4808 8.75764 6.60191 9.13445 6.84415L13.5649 9.69231C13.8919 9.90251 14.0554 10.0076 14.1119 10.1412C14.1612 10.258 14.1612 10.3898 14.1119 10.5065C14.0554 10.6402 13.8919 10.7453 13.5649 10.9555L9.13445 13.8036C8.75764 14.0459 8.56924 14.167 8.41344 14.1559C8.27766 14.1462 8.15279 14.078 8.07121 13.969C7.9776 13.844 7.9776 13.62 7.9776 13.1721V7.47573Z"
            stroke="#F04438"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (libtype === constants.libTypeIds.CODING_SNIPPET) {
      return (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7094 6.56973H0.938538M12.201 14.5473L14.5474 12.201L12.201 9.85462M8.44687 9.85462L6.10052 12.201L8.44687 14.5473M0.938538 5.44348L0.938538 13.3272C0.938538 14.9041 0.938538 15.6926 1.24542 16.2949C1.51537 16.8247 1.9461 17.2554 2.4759 17.5253C3.07819 17.8322 3.86664 17.8322 5.44354 17.8322H15.2044C16.7813 17.8322 17.5697 17.8322 18.172 17.5253C18.7018 17.2554 19.1325 16.8247 19.4025 16.2949C19.7094 15.6926 19.7094 14.9041 19.7094 13.3272V5.44348C19.7094 3.86658 19.7094 3.07813 19.4025 2.47584C19.1325 1.94604 18.7018 1.51531 18.172 1.24536C17.5697 0.938478 16.7813 0.938478 15.2044 0.938478L5.44354 0.938477C3.86664 0.938476 3.07819 0.938476 2.4759 1.24536C1.9461 1.5153 1.51537 1.94604 1.24542 2.47583C0.938538 3.07813 0.938538 3.86658 0.938538 5.44348Z"
            stroke="#2E90FA"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (libtype === constants.libTypeIds.DESCRIPTIVE) {
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3016 18.6097H10.7933M0.938599 19.079L6.14682 17.0759C6.47995 16.9477 6.64651 16.8837 6.80234 16.8C6.94076 16.7257 7.07272 16.64 7.19683 16.5436C7.33656 16.4352 7.46275 16.309 7.71513 16.0566L18.3016 5.47016C19.3383 4.43347 19.3383 2.75268 18.3016 1.71599C17.265 0.679306 15.5842 0.679305 14.5475 1.71599L3.96097 12.3025C3.70859 12.5549 3.5824 12.681 3.47397 12.8208C3.37766 12.9449 3.2919 13.0769 3.2176 13.2153C3.13395 13.3711 3.06988 13.5377 2.94176 13.8708L0.938599 19.079ZM0.938599 19.079L2.87023 14.0568C3.00846 13.6975 3.07757 13.5178 3.19611 13.4355C3.29971 13.3635 3.4279 13.3363 3.55178 13.36C3.69353 13.387 3.82967 13.5232 4.10194 13.7955L6.22219 15.9157C6.49446 16.188 6.63059 16.3241 6.65766 16.4659C6.68132 16.5897 6.65412 16.7179 6.58219 16.8215C6.49988 16.9401 6.32019 17.0092 5.9608 17.1474L0.938599 19.079Z"
            stroke="#F79009"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
  };

  const renderCustomData = (row, rowIndex, columns) => {
    return (
      <>
        <tr key={rowIndex} className="tableBodyRow">
          <td className={`tableData Topic  Topic`}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {getIcon(
                row?.Libtype,
                row?.isVideoQn,
                row?.autoEval,
                row?.aiMode,
              )}
              {row?.Topic}
            </div>
          </td>
          <td style={{ textAlign: "center" }}>{row?.Score}</td>
        </tr>
      </>
    );
  };

  const getTestAttemptDetails = async (learnerid, testid) => {
    Alert.setIsLoaded(true);
    axios
      .get(
        `node/learner/${learnerid}/mock/completed?testid=${testid}`,
        getHeaderDetailsForAxios(),
      )
      .then((res) => {
        if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.message,
          });
        } else {
          // console.log("res:", res);
          const woAIQuestions = res.data.data.tests?.filter(
            (data) => !data.aiMode,
          );
          console.log("woAiQuestion:", woAIQuestions);
          // console.log(
          //   "woAIQuestions.attempteddata:",
          //   woAIQuestions[0].attempteddata,
          // );
          setTestData(woAIQuestions);
          setGraphData(
            JSON.parse(woAIQuestions[0].attempteddata)
              .filter((attempt) => attempt.actualscore >= 0)
              .map((attempt, index) => ({
                attempt: index + 1,
                score: attempt.actualscore,
                targetscore: attempt.targetscore,
              })),
          );
          console.log("graphData:", graphData);

          setAttemptedData(JSON.parse(woAIQuestions[0].attempteddata));
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  };

  const renderCustomDataReportPage = (row, rowIndex, columns) => {
    // console.log("row:", row);

    return (
      <>
        <tr key={rowIndex} className="tableBodyRow">
          {columns.map((col) => {
            const cellId = `${rowIndex}-${col.key}`;
            const isHoverable = row[`${col.key}_hower`];

            if (col.key === "Name") {
              return (
                <UserReportProvider key={cellId}>
                  <NameCell row={row} rowIndex={rowIndex} pos="batch-report-page-container" />
                </UserReportProvider>
              );
            }
            return (
              <td
                className={`tableData ${col.key} ${col.key} ${
                  row[col.key] ? "isthere" : ""
                } ${isHovered === cellId && isHoverable ? "hoverable" : ""}`}
                key={cellId}
                onMouseEnter={() => setIsHovered(cellId)}
                onMouseLeave={() => setIsHovered(null)}
                onClick={() => {
                  if (
                    row[col.key] &&
                    !isHoverable &&
                    getDataFromStorage("role") !== constants.Roles.tutor &&
                    col.key !== "Name"
                  ) {
                    mockReportClick({
                      row,
                      data: row[col.key],
                      col,
                      learnerid: row["learnerid"],
                    });
                  }
                }}
              >
                {row[col.key] ?? "-"}
                {isHovered === cellId && isHoverable && (
                  <svg
                    width="12"
                    height="10"
                    viewBox="0 0 12 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      if (
                        getDataFromStorage("role") !== constants.Roles.tutor
                      ) {
                        setFormOpen(true);
                        setClickedRowLearnerId(row["learnerid"]);
                        setClickedLearnerName(row["Name"]);
                        setClickedRow(row);
                        setClickedColumn(col);
                        getTestAttemptDetails(
                          row["learnerid"],
                          +col.key.split("_")[1],
                        );
                      }
                    }}
                  >
                    <path
                      d="M0.799988 9.13314L4.96665 4.96647L0.799988 0.799805M6.63332 9.13314L10.8 4.96647L6.63332 0.799805"
                      stroke="#667085"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </td>
            );
          })}
        </tr>
      </>
    );
  };

  // console.log("attemptData:",attemptedData);

  const mockReportClick = ({
    row,
    data,
    col,
    testData,
    attemptNo,
    learnerid,
  }) => {
    console.log("row:", row, "data:", data, "col:", col, "testData", testData);
    let testid, lmpid, lmtid, tname, libtype, withAI, marks, status, learnerId;
    learnerId = learnerid ?? clickedRowLearnerId;
    if (testData) {
      // console.log("testdata:", testData);
      let parsedAttemptedData = JSON.parse(testData.attempteddata);
      let attemptData = parsedAttemptedData[attemptNo];
      testid = testData.tid;
      tname = testData.name;
      libtype = testData.libtype;
      withAI = testData.aiMode;
      lmpid = attemptData.lmpid;
      lmtid = attemptData.lmtid;
      marks = attemptData.actualscore;
      status = attemptData?.status;
      Alert.setMockTestReportTopic((prev) => {
        const updated = prev.map(({ title }, index) => ({
          value: index,
          label: title,
          row: clickedRow,
          col: clickedColumn,
          batchid: id,
        }));

        const current = updated.find((item) => item.label === tname);
        Alert.setMockTestReportCurrentTopic(current);
        return updated;
      });
    } else {
      if (!data) {
        return;
      }

      const reqColumns = Object.keys(row).filter((r) => r.startsWith(col.key));
      console.log("col.keu:", col, row);
      console.log("reqCOl:", reqColumns);

      const libtypeKey = reqColumns.filter((r) => r.endsWith("_libtype"));
      libtype = row[libtypeKey];
      const lmtidKey = reqColumns.filter((r) => r.endsWith("lmtid"));
      const lmpidKey = reqColumns.filter((r) => r.endsWith("lmpid"));
      const statusKey = reqColumns.filter((r) => r.endsWith("status"));

      lmpid = row[lmpidKey];
      lmtid = row[lmtidKey];
      marks = data.split("/")[0];

      testid = col.key.split("_").pop();
      tname = col.title;
      status = row[statusKey];
      Alert.setMockTestReportTopic((prev) => {
        const updated = prev.map(({ title }, index) => ({
          value: index,
          label: title,
          row,
          col,
          batchid: id,
        }));

        const current = updated.find((item) => item.label === tname);
        Alert.setMockTestReportCurrentTopic(current);

        return updated;
      });
    }

    console.log("clcicekdeRow:", clickedRowLearnerId, learnerId, libtype);

    if (+libtype === constants.libTypeIds.CODING_CHALLENGE) {
      navigate(`/batches/${id}/dashboard/config`);
      const testdata = {
        id: testid,
        name: tname,
        mode: 2,
        videoqn: 0,
        libtype: constants.libTypeIds.CODING_CHALLENGE,
        viewtest: 1,
        learnerid: learnerId,
        lmtid: lmtid,
        lmpid: lmpid,
        status: status,
      };
      MockTestLibraryHks.handleTest(testdata);
    } else {
      const testdata = {
        id: testid,
        name: tname,
        mode: 2,
        videoqn: 0,
        status: status ?? 2,
        withAI: withAI ?? 0,
        libtype: libtype,
        testtype: libtype,
        viewtest: 1,
        learnerid: learnerId,
        lmtid: lmtid,
        lmpid: lmpid,
        //   duration: test.testduration,
        //   questionscount: test.questionscount,
        marks: marks,
      };
      console.log("testData:", testdata);
      MockTestResultsHks.handleView(testdata);
    }
  };

  // useEffect(() => {
  //   console.log("graphData:", graphData);
  // }, [graphData]);

  // console.log("data:", data);
  // console.log("reportColumns:", reportColumns);

  return (
    <div className="mock-test-report-main-container">
      {isDataLoading && <Loading overlay />}
      {fromPage === "reportpage" && (
        <div className="mock-test-report-page-container">
          <div className="mock-test-report-helper-container">
            <Search
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
            />
            <div
              className="downloadDropdown"
              ref={downloadIconRef}
              style={{ position: "relative", zIndex: 1000 }}
            >
              {showDownloadOptionsDropDown && (
                <div
                  className="downloadOptions"
                  // onMouseLeave={() => setShowDownloadOptionsDropDown(false)}
                  style={{
                    position: "absolute",
                    right: 0,
                    left: "-80px",
                    top: "100%",
                    marginTop: "4px",
                    backgroundColor: "white",
                    border: "1px solid #E4E7EC",
                    borderRadius: "8px",
                    boxShadow:
                      "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    padding: "4px",
                    minWidth: "120px",
                    zIndex: 10, // Fixed: Set very high to appear above header menus
                  }}
                >
                  <div
                    className="option"
                    onClick={handlePdfDownload}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 12px",
                      cursor: isDataLoading ? "not-allowed" : "pointer",
                      borderRadius: "6px",
                      transition: "background-color 0.2s",
                      opacity: isDataLoading ? 0.5 : 1,
                    }}
                    onMouseEnter={(e) =>
                      !isDataLoading &&
                      (e.currentTarget.style.backgroundColor = "#F9FAFB")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <span className="svgiconfordownload">
                      <i
                        className="fa fa-file-pdf-o"
                        style={{
                          color: "red",
                          width: "20px",
                          height: "18px",
                        }}
                      ></i>
                    </span>
                    <p
                      className="optiontext"
                      style={{ margin: 0, fontSize: "14px", fontWeight: 500 }}
                    >
                      PDF
                    </p>
                  </div>
                  <div
                    className="option"
                    onClick={handleCsvDownload}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 12px",
                      cursor: isDataLoading ? "not-allowed" : "pointer",
                      borderRadius: "6px",
                      transition: "background-color 0.2s",
                      opacity: isDataLoading ? 0.5 : 1,
                    }}
                    onMouseEnter={(e) =>
                      !isDataLoading &&
                      (e.currentTarget.style.backgroundColor = "#F9FAFB")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <span className="svgiconfordownload">
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8247 1.50248H12.486C12.4596 1.50248 12.4397 1.50248 12.4133 1.50908V-0.00297165L0 1.41664V16.5437L12.4133 18.003V16.4513C12.4397 16.4513 12.4596 16.4579 12.486 16.4579H18.8247C19.135 16.4579 19.4322 16.3391 19.6567 16.1212C19.8745 15.9033 20 15.6127 20 15.3024V2.65797C20 2.34764 19.8745 2.05711 19.6567 1.83922C19.4322 1.62793 19.135 1.50248 18.8247 1.50248ZM3.52592 9.88148C3.73721 9.88148 3.9485 9.84846 4.14658 9.78244L4.25883 10.3965C4.12017 10.4625 3.81644 10.5352 3.41367 10.522C2.31099 10.4955 1.75636 9.76263 1.75636 8.81182C1.75636 7.67613 2.51568 7.02245 3.4863 6.99604C3.86926 6.98283 4.16639 7.06207 4.29845 7.12809L4.14658 7.74876C3.9485 7.66953 3.73721 7.62331 3.51931 7.62991C2.93826 7.63651 2.49587 8.01287 2.49587 8.759C2.50248 9.43909 2.87884 9.86827 3.52592 9.88148ZM5.5926 10.5748C5.20304 10.5616 4.81347 10.4493 4.62859 10.3371L4.78706 9.69C5.05117 9.82866 5.3417 9.90789 5.64543 9.92109C6.00858 9.9277 6.20007 9.77583 6.20007 9.54473C6.20007 9.32024 6.035 9.19478 5.61902 9.04292C5.05117 8.83823 4.68141 8.51469 4.68141 8.01287C4.68141 7.41862 5.16342 6.94982 5.97557 6.93001C6.37174 6.9168 6.66887 6.99604 6.88016 7.08848L6.70188 7.74876C6.47078 7.64312 6.21987 7.58369 5.96236 7.59029C5.62562 7.5969 5.46055 7.75536 5.46055 7.94024C5.46055 8.16474 5.65203 8.26378 6.10102 8.42885C6.72829 8.65995 7.02542 8.99009 7.02542 9.49851C7.01882 10.0994 6.55662 10.6012 5.5926 10.5748ZM9.44206 10.621L8.43843 10.5946L7.25652 6.95642L8.16771 6.93661L8.62331 8.48168C8.74876 8.91746 8.86761 9.34005 8.96005 9.80224H8.97986C9.0723 9.35985 9.19775 8.91746 9.32321 8.49488L9.81842 6.89699L10.7626 6.87058L9.44206 10.621ZM19.3265 15.2958C19.3265 15.4279 19.2737 15.5533 19.1812 15.6458C19.0888 15.7382 18.9567 15.791 18.8247 15.791H12.486C12.4596 15.791 12.4397 15.791 12.4133 15.7844V2.16936C12.4397 2.16276 12.4596 2.16276 12.486 2.16276H18.8247C18.9567 2.16276 19.0888 2.21558 19.1812 2.30802C19.2737 2.40046 19.3265 2.52592 19.3265 2.65797V15.2958Z"
                          fill="#0B8938"
                        />
                      </svg>
                    </span>
                    <p
                      className="optiontext"
                      style={{ margin: 0, fontSize: "14px", fontWeight: 500 }}
                    >
                      CSV
                    </p>
                  </div>
                </div>
              )}
              <Tooltip placement="bottom" title="Download" isIcon={true}>
                <IconButton
                  hierarchy="tertiaryGrey"
                  onClick={() =>
                    setShowDownloadOptionsDropDown((prev) => !prev)
                  }
                  disabled={data?.length === 0 || isDataLoading}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>

          <Table
            columns={reportColumns}
            data={data}
            onColClick={mockReportClick}
            renderRow={renderCustomDataReportPage}
            // onRowClick={mockReportClick}
          />
          <PaginationComponent
            current={paginationPageNo}
            total={totalPagesForPagination}
            className={"mocktest"}
            onChange={handlePageChange}
          />
        </div>
      )}
      {fromPage === "activitypage" && (
        <div className="mock-test-activity-page-container">
          <div className="mock-activity-page-admin-header">
            <div
              className={`mock-activity-page-admin-header-title`}
            >{`Attempted`}</div>
          </div>
          <div
            className="ccandmocktest-report-header-main-container"
            ref={containerRef}
          >
            {headerData &&
              headerData.length &&
              headerData.map((data) => (
                <ReportTypesCard data={data} onClick={handleCardClick} />
              ))}
          </div>
          <Table
            columns={activityColumn}
            data={data}
            renderRow={renderCustomData}
          />
        </div>
      )}

      <Drawer
        open={formOpen}
        anchor="right"
        width="500px"
        title={clickedLearnerName}
        onClose={() => setFormOpen(false)}
        className="mocktestreport"
      >
        <div className="header">Attempt History</div>
        <div className="attemptCardContainer">
          {attemptedData.map((attempt, index) => (
            <AttemptCard
              key={index}
              test={testData[0]}
              attemptNo={attempt.atmptcount}
              score={
                attempt.actualscore < 0
                  ? `-/${attempt.targetscore}`
                  : `${attempt.actualscore}/${attempt.targetscore}`
              }
              date={attempt.submitteddate}
              mockReportClick={mockReportClick}
            />
          ))}
        </div>
        <div className="attemptGraph">
          {graphData && graphData.length >= 2 && (
            <GraphForAttempts attemptedData={graphData} />
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default MockTestReport;
